import { View, Text, Image, Dimensions, Slider, Platform } from "react-native";
import React from "react";
import { happyKidsJumping } from "../../imports";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import GalleryIcon from "../../assets/svg/GalleryIcon";
import SliderCard from "../custom/SliderCard";
import { FlatList, ScrollView } from "react-native-gesture-handler";
import { useState } from "react";
import { useEffect } from "react";
import getLatestTutorials from "../../api/home/getLatestTutorials";
import { useSelector } from "react-redux";

export default function LearningSlider() {
  const [items, setItems] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
  const main = useSelector((store) => store.main);
  useEffect(() => {
    getLatestTutorials(10)
      .then(({ data }) => {
        if (data.status === 200) {
          setItems(data.data);
        }
      })
      .catch((err) => {});
  }, [refreshing]);
  return (
    <View style={{ width: "100%", overflow: "hidden" }}>
      <View style={{ width: "100%" }}>
        <Image
          style={{
            width: "100%",
            height: (Dimensions.get("screen").width * 432) / 612,
          }}
          resizeMode="contain"
          source={happyKidsJumping}
        />
      </View>
      <View></View>
      <View
        style={{
          width: "100%",
          backgroundColor: "#9FCC3B",
          height: 100,
          padding: 10,
          zIndex: 10,
          overflow: "visible",
        }}
      >
        <View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginVertical: 10,
              overflow: "visible",
              zIndex: 10,
            }}
          >
            <View>
              <GalleryIcon />
            </View>
            <MyText
              style={{
                fontSize: 20,
                marginHorizontal: 10,
                fontWeight: "bold",
                color: "white",
              }}
            >
              {translate("tutorials")}
            </MyText>
          </View>
        </View>
        <View style={{ height: 310 }}>
          <FlatList
            horizontal
            inverted={Platform.OS === "android" && main.rtl}
            data={items}
            style={{ height: 310, overflow: "visible" }}
            renderItem={({ item, index }) => (
              <SliderCard
                setRefreshing={setRefreshing}
                title={main.rtl ? item.titleFa : item.titleEn}
                type={item.type}
                url={item.picURl}
                likes={item.cLike}
                image={item.picURl}
                id={item.id}
                store={item.store}
                kind={item.kind}
                bought={item.isBuy}
              />
            )}
          />
        </View>
      </View>
      <View style={{ alignItems: "center", zIndex: -10 }}>
        <View
          style={{
            width: Dimensions.get("screen").width * 1.5,
            height: Dimensions.get("screen").width * 1.5,
            marginTop: -0.85 * Dimensions.get("screen").width,
            zIndex: -10,
            borderRadius: 2000,
            backgroundColor: "#9FCC3B",
            paddingTop: 0.83 * Dimensions.get("screen").width,
            alignItems: "center",
          }}
        ></View>
      </View>
    </View>
  );
}
